module.exports = __webpack_public_path__ + "static/media/003_Query Builder UI Patterns.4cbb2638.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/backtrace/003_Query Builder UI Patterns.png
// module id = 368
// module chunks = 0